import gql from 'graphql-tag';

export default gql`
  fragment UrlMetadata on UrlMetadata {
    provider_display
    provider_name
    provider_url
    title
    url
    original_url
    description
    images {
      url
      bucket
      file_key
      url_proxy
      url_original
      caption
      height
      width
      size
      primary
    }
    media {
      duration
      height
      width
      type
      html
      url
      bucket
      file_key
      url_proxy
      url_original
    }
  }
`;
